import React, { useState } from 'react'
import { MDBContainer, MDBFooter, MDBIcon, MDBRow, MDBCol, MDBModal, MDBModalBody, MDBModalHeader } from 'mdbreact'
import { HashLink as Link } from 'react-router-hash-link';
import pageConstruction from '../img/page-construction.json';
import Error from './loaders/Error';
import Lottie from 'lottie-react-web';
//graphql
import { useQuery } from '@apollo/react-hooks';
import SOCIALS_QUERY from '../queries/socials'
import FluidLoader from './loaders/FluidLoader';

const FooterWhite = () => {
    const { data, loading, error } = useQuery(SOCIALS_QUERY)
    const [show, setShow] = useState(false)

    if(loading) return <FluidLoader/>
    if(error) return <Error/>

    const { facebook, instagram, shop, pinterest, twitter } = data.socialAccount
    
    return (
        <>
            <MDBFooter color="z-depth-0" transparent className="font-small black-text pt-4 pt-lg-5 pt-md-5">
                <MDBContainer fluid className="text-center text-md-left">
                    <MDBRow>
                        <MDBCol className="pr-lg-5 pr-md-5" lg="4" md="4">
                            <p className="text-capitalize my-2">
                                Follow Minimuni
                            </p>
                            <div className="d-flex justify-content-between mt-4">
                                <a href={facebook} className="black-text">
                                    <MDBIcon size="lg" fab icon="facebook-f"/>
                                </a>
                                <a href={pinterest} className="black-text">
                                    <MDBIcon size="lg" fab icon="pinterest-p"/>
                                </a>
                                <a href={instagram} className="black-text">
                                    <MDBIcon size="lg" fab icon="instagram" />  
                                </a>
                                <a href={twitter} className="black-text">                  
                                    <MDBIcon size="lg" fab icon="twitter"/>
                                </a>
                            </div>
                        </MDBCol>
                        <hr className="clearfix w-100 d-md-none pb-3"/>
                        <MDBCol className="pl-lg-5 pl-md-5" lg="8" md="8">
                            <MDBRow>
                                <MDBCol md="3">
                                    <h5 class="font-weight-bold text-capitalize my-2">Inside Minimuni</h5>

                                    <ul class="list-unstyled font-weight-bold" style={{"line-height": "2"}}>
                                    <li>
                                        <Link smooth to="/blogs" class="black-text">Blog</Link>
                                    </li>
                                    <li>
                                        <Link class="black-text" to="/about">About Us</Link>
                                    </li>
                                    <li>
                                        <Link smooth to="/about#team" class="black-text">Team</Link>
                                    </li>
                                    <li>
                                        <Link class="black-text" to="/advocacy">Advocacy</Link>
                                    </li>
                                    </ul>    
                                </MDBCol>
                                <MDBCol md="3">
                                    <h5 class="font-weight-bold my-2">Get in Touch</h5>

                                    <ul class="list-unstyled font-weight-bold" style={{"line-height": "2"}}>
                                        <li>
                                            <Link smooth to="/contact#contact-us" class="black-text">Contact</Link>
                                        </li>
                                        <li>
                                            <a href="mailto:wilcaoconer@theminimuni.com" class="black-text">Email</a>
                                        </li>
                                        <li>
                                            <a class="black-text" href="https://theminimuni.com/pages/contact.html">Live Chat</a>
                                        </li>
                                        <li>
                                            <a href="https://theminimuni.com/pages/contact.html" class="black-text">Help Center</a>
                                        </li>
                                    </ul>    
                                </MDBCol>
                                <MDBCol md="3">
                                    <h5 class="font-weight-bold text-capitalize my-2">Shopping</h5>

                                    <ul class="list-unstyled font-weight-bold" style={{"line-height": "2"}}>
                                    <li>
                                        <div onClick={()=>setShow(!show)} class="cursor-pointer-style black-text">Products</div>
                                    </li>
                                    <li>
                                        <div onClick={()=>setShow(!show)} class="cursor-pointer-style black-text">Orders</div>
                                    </li>
                                    <li>
                                        <Link smooth to="/#product-reviews" class="black-text">Reviews</Link>
                                    </li>
                                    </ul>    
                                </MDBCol>
                                <MDBCol md="3">
                                    <h5 class="font-weight-bold text-capitalize my-2">Affiliate Program</h5>

                                    <ul class="list-unstyled font-weight-bold" style={{"line-height": "2"}}>
                                        <li>
                                            <Link to="/blog" class="black-text">Becoming One</Link>
                                        </li>
                                        <li>
                                            <Link smooth to="/advocacy#partners" class="black-text">Our Partners</Link>
                                        </li>
                                    </ul>    
                                </MDBCol>
                            </MDBRow>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
                <div className="black-text text-center pt-4 pb-5">
                    <MDBContainer fluid>
                        <div className="d-flex black-text">          
                            <span>&#169;&nbsp;</span> <span>{new Date().getFullYear()} <a className="black-text" href="https://www.theminimuni.com"> Minimuni </a></span>
                            <span className="text-center mx-auto">
                                Made with <span role='img' aria-label="heart">❤️</span> by <a className="black-text" href="https://www.facebook.com/fredgaringo"> Fred Garingo </a>
                            </span>
                        </div>
                    </MDBContainer>
                </div>
            </MDBFooter>
        <MDBModal isOpen={show} centered>
            <MDBModalHeader toggle={()=>setShow(!show)} style={{ border: 0 }}/>
            <MDBModalBody>
            <div className="p-5">
                <div className="text-center">
                <div>
                    <Lottie
                    options={{
                        animationData: pageConstruction
                    }}
                    />
                </div>
                <div className="mt-4">
                    <p className="font-weight-bold">
                      We'll be leaving the Blog part of Minimuni, we'll now go to the E-Commerce part of Minimuni.
                    </p>
                </div>
                <div>
                    <a href={shop} className="newsletter-subscription-button z-depth-1">I understand</a>
                </div>
                </div>
            </div>
            </MDBModalBody>
        </MDBModal> 
        </>
    )
}

export default FooterWhite
